/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GivenRoleDto
 */
export interface GivenRoleDto {
    /**
     * 
     * @type {any}
     * @memberof GivenRoleDto
     */
    id?: any | null;
    /**
     * 
     * @type {any}
     * @memberof GivenRoleDto
     */
    organizationId?: any | null;
    /**
     * 
     * @type {Date}
     * @memberof GivenRoleDto
     */
    expiredAt?: Date | null;
}

/**
 * Check if a given object implements the GivenRoleDto interface.
 */
export function instanceOfGivenRoleDto(value: object): value is GivenRoleDto {
    return true;
}

export function GivenRoleDtoFromJSON(json: any): GivenRoleDto {
    return GivenRoleDtoFromJSONTyped(json, false);
}

export function GivenRoleDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GivenRoleDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] === undefined ? undefined : json['id'] === null ? null : json['id'],
        'organizationId': json['organizationId'] === undefined ? undefined : json['organizationId'] === null ? null : json['organizationId'],
        'expiredAt': json['expiredAt'] === undefined ? undefined : json['expiredAt'] === null ? null : (new Date(json['expiredAt'])),
    };
}

export function GivenRoleDtoToJSON(json: any): GivenRoleDto {
    return GivenRoleDtoToJSONTyped(json, false);
}

export function GivenRoleDtoToJSONTyped(value?: GivenRoleDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'organizationId': value['organizationId'],
        'expiredAt': value['expiredAt'] == null ? value['expiredAt'] : value['expiredAt'].toISOString(),
    };
}

